<template>
  <div class="software_download_wrapper">
    <v-header :status="false" />
    <!-- <div class="title"></div> -->
    <div class="content">
      <div class="left">
        <div>软件下载中心</div>
        <div>
          <div
            :class="curMenuIndex == index ? 'selected' : ''"
            @click="changeTab(index, menu)"
            v-for="(menu, index) in menus"
            :key="index"
          >
            {{ menu.name }}
          </div>
        </div>
      </div>
      <div :class="!isEdit ? 'right' : 'right-input'">
        <div class="title"></div>
        <div v-if="curMenuIndex == 0 && !isEdit && !canRead" class="sn-box">
          <div>您的SN：{{ input1 + input2 + input3 + input4 }}</div>
          <div @click="startEdit">重新输入</div>
        </div>
        <div v-if="curMenu.type == 'url'">
          <template v-if="!isEdit">
            <template v-for="(item, index) in curMenu.children">
              <div v-if="item.url" :key="index">
                <div>
                  <img :src="curMenu.icon" />
                  <div class="name">{{ item.name }}</div>
                  <div class="downloadBtn" @click="download(item.url)">
                    下载
                  </div>
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="">
              <div class="input-title">请输入设备SN号</div>
              <div class="input-box" @click="startEdit">
                <div class="tran_input">
                  <el-input
                    ref="input"
                    type="number"
                    v-model="input"
                    maxlength="12"
                    @input="inputText"
                    autofocus="true"
                  ></el-input>
                </div>
                <div class="input_border">{{ this.input1 }}</div>
                <div style="margin:0px 10px;" class="line"></div>
                <div class="input_border">{{ this.input2 }}</div>
                <div style="margin:0px 10px" class="line"></div>
                <div class="input_border">{{ this.input3 }}</div>
                <div style="margin:0px 10px" class="line"></div>
                <div class="input_border">{{ this.input4 }}</div>
              </div>
              <div class="error-txt" v-show="errorMessage.length > 0">
                SN号不正确，请重新输入
              </div>
              <div class="submit-button" @click="submit">确定</div>
            </div>
          </template>
        </div>
        <div v-else-if="curMenu.type == 'scan'">
          <template v-for="(item, index) in curMenu.children">
            <div v-if="item.url" :key="index">
              <img
                class="right_icon"
                :src="rightIconMap[item.type].icon"
                @click="item.type = rightIconMap[item.type].type"
              />
              <div v-if="item.type == 'url'">
                <img :src="curMenu.icon" />
                <div class="name">{{ item.name }}</div>
                <div class="downloadBtn" @click="download(item.url)">下载</div>
              </div>
              <div v-else-if="item.type == 'scan'" class="qr_wrapper">
                <vue-qr
                  :text="item.url"
                  :size="360"
                  colorDark="#043C83"
                  colorLight="#FFFFFF"
                >
                </vue-qr>
                扫码下载
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VHeader from "../components/Header.vue";
import api from "../api/request.js";
import vueQr from "vue-qr";
export default {
  name: "Software-Download",
  components: {
    VHeader,
    vueQr,
  },
  data() {
    return {
      wordLength: 12,
      curMenuIndex: 0,
      curMenu: {
        name: "魔估二手车Pro (8吋）",
        type: "url",
        icon: require("../assets/mogo_icon_2x.png"),
        children: [
          {
            name: "魔估二手车Pro (8吋）",
            url: "",
          },
          {
            name: "魔估二手车诊断",
            url: "",
          },
        ],
      },
      menus: [
        {
          name: "魔估二手车Pro (8吋）",
          icon: require("../assets/mogo_icon_2x.png"),
          type: "url",
          children: [
            {
              name: "魔估二手车Pro (8吋）",
              url: "",
            },
            {
              name: "魔估二手车诊断",
              url: "",
            },
          ],
        },
        {
          name: "魔估二手车Pro+ (10吋）",
          icon: require("../assets/mogo_icon_2x.png"),
          type: "url",
          children: [
            {
              name: "魔估二手车Pro+ (10吋）",
              url:
                "https://mrdata-adplatform.oss-cn-shenzhen.aliyuncs.com/images/mogo_valuation/apk/mogo_10_release_5.2.2_202403121816.apk",
            },
            {
              name: "魔估二手车诊断",
              url:
                // "http://mrdata-adplatform.oss-cn-shenzhen.aliyuncs.com/images/mogo_valuation/apk/x431MR_MOGO_V7.00.005_zhengshi.apk",
                "https://mrdata-adplatform.mingruidata.com/images/mogo_valuation_apk/x431MR_MOGO_RYUC_V7.00.014_zhengshi.apk",
            },
          ],
        },
        {
          name: "估车宝 (车商版）",
          icon: require("../assets/gcb_icon_2x.png"),
          type: "scan",
          children: [
            {
              name: "估车宝APP",
              type: "url",
              url:
                "http://mrdata-adplatform.oss-cn-shenzhen.aliyuncs.com/images/mogo_valuation/apk/guchebao_release_1.0.0_202203311700.apk",
            },
            {
              name: "估车宝诊断APP",
              type: "url",
              url:
                "http://mrdata-adplatform.oss-cn-shenzhen.aliyuncs.com/images/mogo_valuation/apk/guchebao_3.5_1.apk",
            },
          ],
        },
        {
          name: "X-431MR",
          icon: require("../assets/x431_icon.png"),
          type: "url",
          children: [
            {
              name: "MR标准版-华为",
              type: "url",
              url:
                "https://mrdata-adplatform-prod.oss-cn-shenzhen.aliyuncs.com/sdk/mr_x431/x431MR_hwc5_V7.00.023_business.apk",
            },
            {
              name: "MR标准版-荣耀",
              type: "url",
              url:
                "https://mrdata-adplatform-prod.oss-cn-shenzhen.aliyuncs.com/sdk/mr_x431/x431MR_Honor_V7.01.026_update_zs.apk",
            },
            {
              name: "MR Pro",
              type: "url",
              url:
                "https://mrdata-adplatform-prod.mingruidata.com/sdk/mr_x431/X431MR_Smartlink_7.00.018_business_C5.apk",
            },
          ],
        },
      ],
      rightIconMap: {
        url: {
          type: "scan",
          icon: require("../assets/qr_2x.png"),
        },
        scan: {
          type: "url",
          icon: require("../assets/pc_2x.png"),
        },
      },
      input: "",
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      isEdit: true,
      errorMessage: "",
      canRead: true,
      reqParams: {
        sn: "",
        sysVersion: "",
      },
    };
  },
  methods: {
    download(url) {
      window.open(url);
    },
    changeTab(index, menu) {
      this.curMenuIndex = index;
      this.curMenu = menu;
      this.isEdit = index == 0;
    },
    startEdit() {
      this.isEdit = true;
      const that = this;
      this.$nextTick(() => {
        that.$refs.input.focus();
      });
    },
    inputText(str) {
      if (str.length > 12) {
        this.input = str.slice(0, 12);
      }
      this.input1 = str.slice(0, 3);
      if (str.length > 3) {
        this.input2 = str.slice(3, 6);
      } else {
        this.input2 = "";
      }
      if (str.length > 6) {
        this.input3 = str.slice(6, 9);
      } else {
        this.input3 = "";
      }
      if (str.length > 9) {
        this.input4 = str.slice(9, 12);
      } else {
        this.input4 = "";
      }
    },
    getApkInfo() {
      api.getApkInfo(this.reqParams).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.isEdit = false;
          this.curMenu.children[0].url = res.data.mogoDownloadUrl;
          this.curMenu.children[1].url = res.data.diagnoseDownloadUrl;
        } else {
          this.errorMessage = res.message;
        }
      });
    },
    submit() {
      if (this.input.length > 0) {
        this.reqParams.sn = this.input;
        this.getApkInfo();
      }
    },
  },
  created() {
    const userAgent = navigator.userAgent;
    if (userAgent) {
      console.log(userAgent);
      if (userAgent.indexOf("KOB2-AL00HN") != -1) {
        this.reqParams.sysVersion = "KOB2-AL00HN";
      } else if (userAgent.indexOf("KOB2KZ-AL00") != -1) {
        this.reqParams.sysVersion = "KOB2KZ-AL00";
      } else if (userAgent.indexOf("BZD-AL00") != -1) {
        this.reqParams.sysVersion = "BZD-AL00";
      } else {
        this.canRead = false;
        this.isEdit = true;
        return;
      }
      //调接口
      this.getApkInfo();
    }
  },
};
</script>
<style lang="less" scoped>
.software_download_wrapper {
  position: relative;
  min-width: 1420px;
  width: 100%;
  margin: 0 auto;
  .title {
    width: 100%;
    height: 100px;
    background-color: #ffffff;
  }
  .content {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    height: calc(100vh - 182px);
    margin: 0px auto;
    .left {
      position: relative;
      width: 580px;
      height: 100%;
      padding-left: 300px;
      box-sizing: border-box;
      background-color: #f8f8f8;
      > div:first-child {
        width: 100%;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-bottom: 50px;
        color: #333333;
        opacity: 1;
      }
      > div:last-child {
        > div {
          position: relative;
          width: 280px;
          height: 54px;
          line-height: 54px;
          cursor: pointer;
          font-size: 20px;
          font-weight: 400;
        }
        > div.selected {
          color: #043c83;
          font-weight: bold;
        }
        > div + div {
          margin-top: 30px;
        }
      }
    }
    .right {
      position: relative;
      box-sizing: border-box;
      padding-left: 40px;
      margin-top: 60px;
      width: 1340px;
      height: 100%;
      border-top: 1px solid #ebebeb;
      border-left: 1px solid #ebebeb;
      > div {
        position: relative;
        display: flex;
        flex-flow: row nowrap;
        > div {
          position: relative;
          > img.right_icon {
            position: absolute;
            top: 0px;
            right: 0px;
            width: 80px;
            height: 80px;
            z-index: 1;
          }
          > div {
            position: relative;
            width: 360px;
            // height: 400px;
            background-color: #ffffff;
            border: 1px solid #d9d9d9;
            box-shadow: 0px 0px 4px rgba(0, 76, 255, 0.16);
            box-sizing: border-box;
            padding-top: 70px;
            padding-bottom: 70px;
            display: flex;
            flex-flow: column nowrap;
            justify-content: space-around;
            align-items: center;
            img {
              width: 90px;
              height: 90px;
              margin-bottom: 40px;
            }
            .name {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              opacity: 1;
              margin-bottom: 60px;
            }
            .downloadBtn {
              text-align: center;
              width: 200px;
              height: 48px;
              line-height: 48px;
              background: rgba(4, 60, 131);
              opacity: 1;
              border-radius: 30px;
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              opacity: 1;
              cursor: pointer;
            }
          }
          > div.qr_wrapper {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 31px;
            color: #333333;
            opacity: 1;
            > img {
              margin-top: 20px;
              width: 180px;
              height: 180px;
              margin-bottom: 33px;
            }
          }
        }
        > div + div {
          margin-left: 60px;
        }
      }
    }
  }
}
.right-input {
  position: relative;
  box-sizing: border-box;
  padding-left: 225px;
  padding-top: 40px;
  width: 1260px;
  height: 100%;
  border-top: 1px solid #ebebeb;
  border-left: 1px solid #ebebeb;
  background: white;
}
.input-box {
  display: flex;
  align-items: center;
  margin-top: 80px;
}
/deep/.el-input__inner {
  // width: 300px;
  height: 0px;
  background: transparent;
  border: 2px solid transparent;
  color: transparent;
  border-radius: 4px;
  font-size: 20px;
  font-weight: bold;
}
.input_border {
  width: 160px;
  height: 60px;
  line-height: 60px;
  background: #ffffff;
  border: 2px solid #5a5a5a;
  border-radius: 4px;
  font-size: 28px;
  text-align: center;
  font-weight: bold;
}
.input-title {
  font-size: 34px;
  margin-left: 220px;
  font-weight: bold;
  color: #333333;
}
.error-txt {
  font-size: 18px;
  font-weight: 500;
  color: #ff0000;
  margin-top: 18px;
}
.submit-button {
  width: 300px;
  height: 54px;
  background: #043c83;
  line-height: 54px;
  border-radius: 30px;
  font-size: 24px;
  font-weight: 400;
  color: white;
  text-align: center;
  margin-top: 112px;
  margin-left: 190px;
  cursor: pointer;
}
.sn-box {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  > div:first-child {
    font-size: 24px;
    font-weight: bold;
  }
  > div:last-child {
    width: 120px;
    height: 30px;
    background: #0049a5;
    border-radius: 3px;
    font-size: 16px;
    font-weight: 400;
    line-height: 30px;
    text-align: center;
    color: white;
    margin-left: 4px;
    cursor: pointer;
  }
}
.line {
  width: 10px;
  height: 2px;
  background: #5a5a5a;
  border-radius: 0px;
}
.tran_input {
  width: 480px;
  position: absolute;
}
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
</style>
